import { call, put, takeLatest } from 'redux-saga/effects';
import * as api from '../../api';
import * as actions from './actions';

export function* verifyExtendResult(productId) {
    const response = yield call(api.extendingResultsStatus, productId);
    if (response.status === 200) {
        yield put(actions.onVerifyExtendResultInfoSuccess({ ...response.data }));
    } else {
        yield put(actions.onVerifyExtendResultInfoFailure());
    }
}

export function* verifyExtendResultSaga() {
    yield takeLatest(actions.VERIFY_EXTEND_RESULT_INFO_REQUEST, verifyExtendResult);
}

export function* extendResults({ selectedProductId, selectedYeargroups }) {
    const response = yield call(api.extendResults, selectedProductId, selectedYeargroups);
    if (response.status === 200) {
        yield put(actions.extendResultsSuccess({ ...response.data }));
    } else {
        yield put(actions.extendResultsFailure());
    }
}

export function* extendResultSaga() {
    yield takeLatest(actions.EXTEND_RESULTS, extendResults);
}



// WEBPACK FOOTER //
// ./app/containers/extend-result/saga.js